<template>
  <div>

    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Award Points</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <b>Award Points</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <router-link :to="{ name: 'add-award-points' }" type="button" class="btn btn-primary"
            style="padding: auto; width: 10%; position: absolute; left: 87%; top: 1%">Add New</router-link>

          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-basic-tab" data-toggle="tab" href="#_individual" role="tab"
                aria-controls="_individual" aria-selected="true">Individual</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="profile-basic-tab" data-toggle="tab" href="#_multiple" role="tab"
                aria-controls="_multiple" aria-selected="false">Multiple</a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active bg-white" id="_individual" role="tabpanel"
              aria-labelledby="individual-tab">
              <div class="card-body">

                <div class="btn-group mb-4" role="group" v-for="(button, index) in buttons" :key="index">
                  <button class="btn btn-secondary" id="btn-inactive" :press.sync="button.status"
                    :class="{ 'change-background': button.status }" @click="onPressBtn(index)" type="button">
                    {{ button.name }}
                  </button>
                </div>


                <h4 class="card-title mb-3">Award Points</h4>

                <div class="row">
                  <div class="col-6">
                    <label><b>Date From</b></label>
                    <input class="form-control" type="date" v-model="date_from" />
                  </div>
                  <div class="col-6">
                    <label><b>Date To</b></label>
                    <input class="form-control" type="date" v-model="date_to" />
                  </div>
                </div>
                <br />

                <div class="row">
                  <div class="text-left col-6">
                    <json-excel class="btn btn-rounded btn-primary mr-1" style="width: 150px" :fetch="CallBackData"
                      :fields="json_fields" type="csv" worksheet="My Worksheet" name="Award Point.csv">
                      Excel
                    </json-excel>
                    <button class="btn btn-rounded btn-primary" style="width: 150px" @click="toPDF()">
                      PDF
                    </button>
                  </div>
                  <div class="text-right col-6">
                    <button class="btn btn-rounded btn-primary mr-1" style="width: 150px" @click="filterDate()">
                      Submit
                    </button>
                    <button type="button" class="btn btn-rounded btn-primary" style="width: 150px" @click="reset()">
                      Reset
                    </button>
                  </div>
                </div>

                <br />
                <div class="input-group mb-4 d-flex flex-row-reverse p2">
                  <button type="button" class="btn btn-primary mr-1" @click="filterSearch">
                    <i class="fas fa-search"></i>
                  </button>
                  <div class="form-outline mr-1">
                    <input type="input" class="form-control" v-model="search" />
                  </div>
                </div>


                <div class="table-responsive">
                  <!-- All -->
                  <table id="vendor_tbl" class="display table table-striped table-bordered"
                    style="width:100%; text-align: center;">
                    <thead>
                      <tr>
                        <th>Date Earned</th>
                        <th>My Takaful ID</th>
                        <th>IC Number</th>
                        <th>Name</th>
                        <th>Mobile Number</th>
                        <th>Descriptions</th>
                        <th>Remarks</th>
                        <th>Points Earned</th>
                        <th width="10">{{checkUser ? 'Action' : 'Status'}}</th>
                      </tr>
                    </thead>
                    <tbody v-if="points.length < 1">
                      <tr>
                        <td colspan="9">No Data</td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr v-for="(point, index) in points" :key="index">
                        <td>{{ point.approved_at }}</td>
                        <td>{{ point.customer.account_number }}</td>
                        <td>{{ point.customer.ic_number }}</td>
                        <td>{{ point.customer.name }}</td>
                        <td>{{ point.customer.mobile_number }}</td>
                        <td>{{ point.description }}</td>
                        <td>{{ point.remarks }}</td>
                        <td>{{ point.point }}</td>
                        <td>
                          <span v-if="checkUser && point.status =='Pending'">
                            <button
                              class="btn btn-rounded btn-success mr-1 mb-1"
                              style="width: 150px"
                              data-toggle="modal"
                              data-target=".award-approve-modal"
                              @click="updatePoint(point)"
                            >
                              Approve
                            </button>
                            <button
                              class="btn btn-rounded btn-danger mr-1"
                              style="width: 150px"
                              data-toggle="modal"
                              data-target=".award-reject-modal"
                              @click="updatePoint(point)"
                            >
                              Reject
                            </button>
                          </span>
                          <span v-else :style="{color: checkStatus(point.status), fontWeight: 'bold'}">{{ point.status }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <pagination v-model="pageInfo.current_page" :per-page="pageInfo.per_page" :records="pageInfo.total"
                    @paginate="handlePageChange" />
                </div>
              </div>
            </div>
            <div class="tab-pane fade bg-white" id="_multiple" role="tabpanel" aria-labelledby="multiple-tab">
              <div class="card-body">

                <div class="btn-group mb-4" role="group" v-for="(button, index) in multiple_buttons" :key="index">
                  <button class="btn btn-secondary" id="btn-inactive" :press.sync="button.status"
                    :class="{ 'change-background': button.status }" @click="onMultiPressBtn(index)" type="button">
                    {{ button.name }}
                  </button>
                </div>

                <h4 class="card-title mb-3">Award Points</h4>

                <div class="row">
                  <div class="col-6">
                    <label><b>Date From</b></label>
                    <input class="form-control" type="date" v-model="multi_date_from" />
                  </div>
                  <div class="col-6">
                    <label><b>Date To</b></label>
                    <input class="form-control" type="date" v-model="multi_date_to" />
                  </div>
                </div>
                <br />

                <div class="row">
                  <div class="text-left col-6">
                    <json-excel class="btn btn-rounded btn-primary mr-1" style="width: 150px" :fetch="MultiCallBackData"
                      :fields="multi_json_fields" type="csv" worksheet="My Worksheet" name="Award Point.csv">
                      Excel
                    </json-excel>
                    <button class="btn btn-rounded btn-primary" style="width: 150px" @click="multiToPDF()">
                      PDF
                    </button>
                  </div>
                  <div class="text-right col-6">
                    <button class="btn btn-rounded btn-primary mr-1" style="width: 150px" @click="filterDateMultiple()">
                      Submit
                    </button>
                    <button type="button" class="btn btn-rounded btn-primary" style="width: 150px" @click="resetMulti()">
                      Reset
                    </button>
                  </div>
                </div>

                <br />
                <div class="input-group mb-4 d-flex flex-row-reverse p2">
                  <button type="button" class="btn btn-primary mr-1" @click="filterSearchMultiple">
                    <i class="fas fa-search"></i>
                  </button>
                  <div class="form-outline mr-1">
                    <input type="input" class="form-control" v-model="multi_search" />
                  </div>
                </div>


                <div class="table-responsive">
                  <!-- All -->
                  <table id="multiple_tbl" class="display table table-striped table-bordered"
                    style="width:100%; text-align: center;">
                    <thead>
                      <tr>
                        <th>Event Name</th>
                        <th>Description</th>
                        <th>Points Awarded</th>
                        <th>Date Awarded</th>
                        <th>Remarks</th>
                        <th width="10">{{checkUser ? 'Action' : 'Status'}}</th>
                      </tr>
                    </thead>
                    <tbody v-if="pointsMultiple.length < 1">
                      <tr>
                        <td colspan="6">No Data</td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr v-for="(point, index) in pointsMultiple" :key="index">
                        <td>
                          <router-link :to="{ name: 'award-event-details', params: { event_id: point.id } }" type="button" style="margin-bottom: 20px;">{{ point.name }}
                          </router-link>
                        </td>
                        <td>{{ point.description }}</td>
                        <td>{{ point.point }}</td>
                        <td>{{ point.approved_at }}</td>
                        <td>{{ point.remarks }}</td>
                        <td>
                          <span v-if="checkUser && point.status =='Pending'">
                            <button
                              class="btn btn-rounded btn-success mr-1 mb-1"
                              style="width: 150px"
                              data-toggle="modal"
                              data-target=".event-approve-modal"
                              @click="updatePoint(point)"
                            >
                              Approve
                            </button>
                            <button
                              class="btn btn-rounded btn-danger mr-1"
                              style="width: 150px"
                              data-toggle="modal"
                              data-target=".event-reject-modal"
                              @click="updatePoint(point)"
                            >
                              Reject
                            </button>
                          </span>
                          <span v-else :style="{color: checkStatus(point.status), fontWeight: 'bold'}">{{ point.status }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <pagination v-model="pageInfoMultiple.current_page" :per-page="pageInfoMultiple.per_page" :records="pageInfoMultiple.total"
                    @paginate="handleMultiPageChange" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade award-approve-modal"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      id="award-individual-approve-modal"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="container py-4 px-4" style="text-align: center;">
            <b><h4 style="text-align: center; color: #AC8400">Award Points to User</h4></b>

            <label style="text-align: center;">Are you sure you want to award {{ awardPoint }} points to this user?</label>

            <div style="text-align: center">
              <button class="btn mr-1" style="width: 100px; color: #AC8400; background-color: white; border-color: #AC8400;" @click="hideModal('#award-individual-approve-modal')">
                Cancel
              </button>
              <button class="btn" style="width: 100px; color: white; background-color: #AC8400; border-color: #AC8400;" @click="onClick(1, '#award-individual-approve-modal', `/loyalty/award/approval/individual`, 1)">
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade award-reject-modal"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      id="award-individual-reject-modal"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="container py-4 px-4" style="text-align: center;">
            <b><h4 style="text-align: center; color: #AC8400">Remarks</h4></b>

            <textarea class="form-control" v-model="reject_remarks"></textarea>

            <br />

            <div style="text-align: center">
              <button class="btn mr-1" style="width: 100px; color: #AC8400; background-color: white; border-color: #AC8400;" @click="hideModal('#award-individual-reject-modal')">
                close
              </button>
              <button class="btn" style="width: 100px; color: white; background-color: #AC8400; border-color: #AC8400;" @click="onClick(0, '#award-individual-reject-modal', `/loyalty/award/approval/individual`, 1)">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div
      class="modal fade event-approve-modal"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      id="event-approve-modal"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="container py-4 px-4" style="text-align: center;">
            <b><h4 style="text-align: center; color: #AC8400">Award Points to Selected User</h4></b>

            <label style="text-align: center;">Are you sure you want to award {{ awardPoint }} points to the selected user?</label>

            <div style="text-align: center">
              <button class="btn mr-1" style="width: 100px; color: #AC8400; background-color: white; border-color: #AC8400;" @click="hideModal('#event-approve-modal')">
                Cancel
              </button>
              <button class="btn" style="width: 100px; color: white; background-color: #AC8400; border-color: #AC8400;" @click="onClick(1, '#event-approve-modal', `/loyalty/award/approval/multiple`, 2)">
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade event-reject-modal"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      id="event-reject-modal"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="container py-4 px-4" style="text-align: center;">
            <b><h4 style="text-align: center; color: #AC8400">Remarks</h4></b>

            <textarea class="form-control" v-model="reject_remarks"></textarea>

            <br />

            <div style="text-align: center">
              <button class="btn mr-1" style="width: 100px; color: #AC8400; background-color: white; border-color: #AC8400;" @click="hideModal('#event-reject-modal')">
                close
              </button>
              <button class="btn" style="width: 100px; color: white; background-color: #AC8400; border-color: #AC8400;" @click="onClick(0, '#event-reject-modal', `/loyalty/award/approval/multiple`, 2)">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Pagination from "vue-pagination-2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import JsonExcel from "vue-json-excel";
import { getRequest, postRequest } from "@/services/RequestService";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';


export default {
  name: "award-points",
  components: { Pagination, JsonExcel },

  data() {
    return {
      type: 'individual',

      points: [],
      _api: `/award/individual`,
      _sign: '?',
      downloadApi: ``,

      pageInfo: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0
      },

      date_from: null,
      date_to: null,
      search: null,

      json_fields: {
        "Date Earned": "created_at",
        "Account Number": "account_number",
        "IC Number": "ic_number",
        "Name": "name",
        "Mobile Number": "mobile_number",
        "Descriptions": "description",
        "Remarks": "remarks",
        "Points Earned": "point",
        "Expiry Date": "expiry_date",
        "Awarded By": "awarded_by",
        "Status": "status"
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

      buttons: [
        { status: true, name: "All" },
        { status: false, name: "Pending" },
        { status: false, name: "Approved" },
        { status: false, name: "Rejected" }
      ],

      all: true,
      pending: false,
      approved: false,
      rejected: false,
      individualStatus: 'all',

      pointsMultiple: [],
      _apiMultiple: `/award/multiple`,
      _signMultiple: '?',
      downloadApiMultiple: ``,
      
      pageInfoMultiple: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0
      },

      multiple_buttons: [
        { status: true, name: "All" },
        { status: false, name: "Pending" },
        { status: false, name: "Approved" },
        { status: false, name: "Rejected" }
      ],

      allMulti: true,
      pendingMulti: false,
      approvedMulti: false,
      rejectedMulti: false,
      multipleStatus: 'all',

      multi_date_from: null,
      multi_date_to: null,
      multi_search: null,

      multi_json_fields: {
        "Event Name": "name",
        "Descriptions": "description",
        "Points Awarded": "point",
        "Date Awarded": "approved_at",
        "Remarks": "remarks",
        "Awarded By": "awarded_by",
        "Status": "status"
      },
      multi_json_data: [],
      multi_json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

      checkUser: false,

      reject_remarks: null,
      awardPoint: 0,
      awardId: null,
    };
  },

  methods: {
    // individual
    async loadData() {

      this._api = `${axios.lpsURL}/award/individual`;
      this.downloadApi = `${this._api}/download?status=${this.individualStatus}`;
      this._sign = `?`;

      try {
        let res = await getRequest(this._api);
        
        this.points = res.data.data[this.individualStatus].awarded_points;
        this.pageInfo = res.data.data[this.individualStatus].pagination;

      } catch (e) {
        console.log(e)
      }
    },

    //multiple
    async loadDataMultiple() {

      this._apiMultiple = `${axios.lpsURL}/award/multiple`;
      this.downloadApiMultiple = `${this._apiMultiple}/download?status=${this.multipleStatus}`;
      this._signMultiple = `?`;

      try {
        let res = await getRequest(this._apiMultiple);
        
        this.pointsMultiple = res.data.data[this.multipleStatus].events;
        this.pageInfoMultiple = res.data.data[this.multipleStatus].pagination;

      } catch (e) {
        console.log(e)
      }
    },

    async handlePageChange(page) {
      try {
        let res = await getRequest(this._api + `${this._sign}page=${page}`);

        this.points = res.data.data[this.individualStatus].awarded_points;
        this.pageInfo = res.data.data[this.individualStatus].pagination;

      } catch (e) {
        console.log(e)
      }
    },

    async handleMultiPageChange(page) {
      try {
        let res = await getRequest(this._apiMultiple + `${this._signMultiple}page=${page}`);

        this.pointsMultiple = res.data.data[this.multipleStatus].events;
        this.pageInfoMultiple = res.data.data[this.multipleStatus].pagination;

      } catch (e) {
        console.log(e)
      }
    },

    async filterDate() {
      this._api = axios.lpsURL + `/award/individual?date_from=${this.date_from}&date_to=${this.date_to}`;
      this.downloadApi = axios.lpsURL + `/award/individual/download?date_from=${this.date_from}&date_to=${this.date_to}`;
      this._sign = `&`;

      try {
        let res = await getRequest(this._api);

        this.points = res.data.data[this.individualStatus].awarded_points;
        this.pageInfo = res.data.data[this.individualStatus].pagination;

      } catch (e) {
        console.log(e)
      }
    },

    async filterSearch() {
      this._api = axios.lpsURL + `/award/individual?search=${this.search}`;
      this.downloadApi = axios.lpsURL + `/award/individual/download?search=${this.search}`;
      this._sign = `&`;

      try {
          let res = await getRequest(this._api);
  
          this.points = res.data.data[this.individualStatus].awarded_points;
          this.pageInfo = res.data.data[this.individualStatus].pagination;
        
      } catch (e) {
        console.log(e)
      }
    },

    async filterDateMultiple() {
      this._apiMultiple = axios.lpsURL + `/award/multiple?date_from=${this.multi_date_from}&date_to=${this.multi_date_to}`;
      this.downloadApiMultiple = axios.lpsURL + `/award/multiple/download?date_from=${this.multi_date_from}&date_to=${this.multi_date_to}`;
      this._signMultiple = `&`;

      try {
        let res = await getRequest(this._apiMultiple);

        this.pointsMultiple = res.data.data[this.multipleStatus].events;
        this.pageInfoMultiple = res.data.data[this.multipleStatus].pagination;
        
      } catch (e) {
        console.log(e)
      }
    },

    async filterSearchMultiple() {
      this._apiMultiple = axios.lpsURL + `/award/multiple?search=${this.multi_search}`;
      this.downloadApiMultiple = axios.lpsURL + `/award/multiple/download?search=${this.multi_search}`;
      this._signMultiple = `&`;

      try {
          let res = await getRequest(this._apiMultiple);
  
          this.pointsMultiple = res.data.data[this.multipleStatus].events;
          this.pageInfoMultiple = res.data.data[this.multipleStatus].pagination;
        
      } catch (e) {
        console.log(e)
      }
    },

    async CallBackData() {
      // clear json_data
      this.json_data = [];

      let res = await getRequest(this.downloadApi);

      for (let i = 0; i < res.data.data.length; i++) {
        this.json_data.push({
          created_at: res.data.data[i].approved_at,
          account_number: res.data.data[i].customer.account_number,
          ic_number: res.data.data[i].customer.ic_number,
          name: res.data.data[i].customer.name,
          mobile_number: res.data.data[i].customer.mobile_number,
          description: res.data.data[i].description,
          remarks: res.data.data[i].remarks,
          point: res.data.data[i].point,
          expiry_date: res.data.data[i].expiry_date,
          awarded_by: res.data.data[i].awarded_by.name,
          status: res.data.data[i].status
        });
      }

      return this.json_data;
    },

    async MultiCallBackData() {
      // clear json_data
      this.multi_json_data = [];

      let res = await getRequest(this.downloadApiMultiple);

      for (let i = 0; i < res.data.data.length; i++) {
        this.multi_json_data.push({
          name: res.data.data[i].name,
          description: res.data.data[i].description,
          point: res.data.data[i].point,
          approved_at: res.data.data[i].approved_at,
          remarks: res.data.data[i].remarks,
          awarded_by: res.data.data[i].approver.name,
          status: res.data.data[i].status
        });
      }

      return this.multi_json_data;
    },

    async toPDF() {
      let datas = await this.CallBackData();

      const new_datas = datas.map(element => Object.values(element));

      let doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });

      autoTable(doc, {
        head: [['Date Earned', 'Account Number', 'IC Number', 'Name', 'Mobile Number', 'Description', 'Remarks', 'Points', 'Expiry Date', 'Awarded By', 'Status']],
        body: new_datas,
      });

      doc.save("Individual Award Point.pdf");
    },

    async multiToPDF() {
      let datas = await this.MultiCallBackData();

      const new_datas = datas.map(element => Object.values(element));

      let doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });

      autoTable(doc, {
        head: [['Event Name', 'Description', 'Point Awarded', 'Date Awarded', 'Remarks', 'Awarded By', 'Status']],
        body: new_datas,
      });

      doc.save("Multiple Award Point.pdf");
    },

    async reset() {
      this.date_from = this.date_to = null;
      this.loadData();
    },

    async resetMulti() {
      this.multi_date_from = this.multi_date_to = null;
      this.loadDataMultiple();
    },

    async onPressBtn(int) {
      this.buttons.forEach((button, index) => {
        button.status = int === index;
      });

      this.checkButtonStatus();
    },

    async onMultiPressBtn(int) {
      this.multiple_buttons.forEach((button, index) => {
        button.status = int === index;
      });

      this.checkMultipleButtonStatus();
    },

    async onClick(type, modal, url, flag) {
      let formData = {};
      
      if(flag == 1) {
        formData = {
          _method: "PATCH",
          award_point_id: this.awardId,
          approval_type: type,
          remarks: this.reject_remarks
        }
      } else {
        formData = {
          _method: "PATCH",
          event_point_id: this.awardId,
          approval_type: type,
          remarks: this.reject_remarks
        }

      }

      try {
        let res = await postRequest(url, formData);

        swal({
          title: res.data.success ? "Success" : "Failed",
          icon: res.data.success ? "success" : "error",
          text: res.data.message,
        });

        $(modal).modal('hide');

        if(res.data.success) {
          this.awardPoint = null;
          this.awardId = null;
          this.reject_remarks = null;
          flag == 1 ?
          this.loadData()
          :
          this.loadDataMultiple();
        }

      } catch (e) {
        console.log(e);
      }
    },

    checkButtonStatus() {
      if(this.buttons[0].status) {
        this.all = true;
        this.individualStatus = 'all';
        this.pending = this.rejected = this.approved = false;
      } else if (this.buttons[1].status) {
        this.pending = true;
        this.individualStatus = 'pending';
        this.all = this.rejected = this.approved = false;
      } else if (this.buttons[2].status) {
        this.approved = true;
        this.individualStatus = 'approved';
        this.all = this.rejected = this.pending = false;
      } else {
        this.rejected = true;
        this.individualStatus = 'rejected';
        this.all = this.approved = this.pending = false;
      }
      this.loadData()
    },

    checkMultipleButtonStatus() {
      if(this.multiple_buttons[0].status) {
        this.allMulti = true;
        this.multipleStatus = 'all';
        this.pendingMulti = this.rejectedMulti = this.approvedMulti = false;
      } else if (this.multiple_buttons[1].status) {
        this.pendingMulti = true;
        this.multipleStatus = 'pending';
        this.allMulti = this.rejectedMulti = this.approvedMulti = false;
      } else if (this.multiple_buttons[2].status) {
        this.approvedMulti = true;
        this.multipleStatus = 'approved';
        this.allMulti = this.rejectedMulti = this.pendingMulti = false;
      } else {
        this.rejectedMulti = true;
        this.multipleStatus = 'rejected';
        this.allMulti = this.approvedMulti = this.pendingMulti = false;
      }
      this.loadDataMultiple()
    },

    checkStatus(status) {
      switch (status) {
        case 'Approved':
          return 'green';
        case 'Rejected':
          return 'red';
        default:
          return 'black';
      }
    },

    updatePoint(point) {
      this.awardPoint = point.point;
      this.awardId = point.id;
      this.reject_remarks = null;
    },

    hideModal(name) {
      $(name).modal('hide');
    },

    async userCheckPrevy() {
      try {
          let res = await getRequest(`${axios.lpsURL}/award/check_permission`);
          this.checkUser = res.data.approver;
      } catch (e) {
        this.checkUser = false;
        console.log(e)
      }
    },

    lps() {
      return this.$lps();
    }
  },

  async created() {
    await this.loadData();
    await this.loadDataMultiple();
    await this.userCheckPrevy();
  },

};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}


</style>
